import { DataService } from '../../services/data.service';
import { observable, action, } from 'mobx';
import { Injectable } from '@angular/core';
import { ILevel, IGrammarInUseContent } from 'src/app/interfaces/resource';
import * as firebase from 'firebase/app';
import { pushToObject, orderBy } from 'src/app/services/convert.service';

@Injectable()
export class GrammarInUseStore {
    @observable data: any[] = [];
    @observable process: boolean = false;
    @observable loading: boolean = true;
    @observable empty: boolean = false;
    @observable lastVisible: any = null;
    @observable fetching: boolean = false;

    constructor(private ds: DataService) { }

    @action
    async fetchSelectedLesson(lessonKey) {
       const doc=await this.ds.grammarInUseRef().doc(lessonKey).get().toPromise()
       return pushToObject(doc);
    }

    @action
    fetchSelectedContent(sectionKey,contentKey,callback) {
       this.ds.grammarInUseRef().doc(sectionKey).collection('contents').doc(contentKey).valueChanges().subscribe(docs=>{
        callback(docs);
       })
    }

    @action
    fetchGrammarInUse(section:boolean) {
        this.loading = true;
        this.ds.grammarInUseDataRef(section).valueChanges().subscribe(docs => {
            this.data =orderBy(docs,'page_key')
            this.empty = docs.length === 0;
            this.loading = false;
        })
    }

    @action
    fetchData(sectionKey) {
        this.loading = true;
        this.ds.grammarInUseRef().doc(sectionKey).collection('contents').valueChanges().subscribe(docs => {
            this.data=docs;
            this.empty=docs.length===0;
            this.loading=false;
        })
    }

    @action
    addContent(item:IGrammarInUseContent,callback){
        this.process=true;
        this.ds.grammarInUseRef().doc(item.sectionKey).collection('contents').doc(item.key).set(item).then(() => {
            callback(true, null);
        }).catch((error) => {
            alert(error);
            callback(false, error)
        }).finally(() => {
            this.process = false;
        })
    }

    @action
    delete(collectionName, item: ILevel, callback) {
        this.loading = true;
        const batch = this.ds.batch();
        const { organizationKey } = item;
        const statisticRef = this.ds.statisticBatchRef().doc(organizationKey);
        const ref = this.ds.batchCollectionRef().collection(collectionName).doc(item.key);
        batch.delete(ref);
        batch.update(statisticRef, { [`${collectionName}`]: firebase.firestore.FieldValue.increment(-1) });
        batch.commit().then(() => {
            callback(true, null);
        }).catch((error) => {
            alert(error);
            callback(false, error)
        }).finally(() => {
            this.loading = false;
        })
    }


}
